<template id="multi-check">
  <input-wrapper
    :error="error"
    :helperText="helperText"
    :disabled="disabled"
    :class="Object.assign({'styled-select': 1, 'multi-check': 1}, classList)">

    <div class="multi-check-dropdown" @click="showDropdown">
      <div class="multi-check-overselect"></div>
      <select class="multi-check-input">
        <option value="">{{ text }}</option>
      </select>
    </div>

    <div class="multi-check-boxes" v-if="show">
      <ul>
        <li v-for="(option, index) in options" :key="index">
          <input type="checkbox" v-model="selected" :id="index" :value="option.value">
          <label :for="index">{{ option.text }}</label>
        </li>
      </ul>
    </div>

    <sprite class="arrow" name="arrow_drop_down" />
  </input-wrapper>
</template>

<script>
  import input from '../../../mixins/input'
  import Sprite from '../../../components/ui/Sprite.vue'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import InputWrapper from '../../../components/ui/inputs/InputWrapper.vue'

  export default {
    name: 'MultiCheck',
    mixins: [input],

    components: {
      Sprite,
      InputLabel,
      InputWrapper,
    },

    props: {
      options: {
        type: Array,
        required: true
      },
      text: {type: String},
      value: {type: Array},
    },

    data () {
      return {
        show: false,
        selected: []
      }
    },

    computed: {
    },

    methods: {
      showDropdown () {
        this.show = !this.show
      }
    },

    watch: {
      value(val) {
        this.selected = val
      },

      selected(val) {
        this.currentValue = val
        this.$emit('input', val)
      },
    },
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .styled-select
    position: relative

    label
      pointer-events: none

    &.disabled
      pointer-events: none

    &.has-value
      .input-label
        transform: translateY(-21px) scale(0.75)

      select
        color: $color-text

    &.has-focus
      .input-label
        transform: translateY(0) scale(1)

      &.has-value
        .input-label
          transform: translateY(-21px) scale(0.75)

      .arrow
        fill: $color-text

    select
      height: 46px
      border: none
      box-shadow: none
      background: transparent
      background-image: none
      -webkit-appearance: none
      -moz-appearance: none
      font-size: $font-size-input
      width: 100%
      cursor: pointer
      transition: color $transition-duration $transition-easing

      *
        color: $color-text

      &:-moz-focusring
        color: transparent
        text-shadow: none

      &:focus
        outline: none
        color: $color-text-light

    .arrow
      width: 20px
      height: 20px
      position: absolute
      right: 0
      top: 28px
      pointer-events: none
      cursor: pointer
      transition: fill $transition-duration $transition-easing
      fill: $color-icon-disabled

  .multi-check
    .input-wrapper
      display: block

      .multi-check-dropdown
        position: relative
        cursor: pointer
        width: 100%

      .multi-check-input
        color: $color-text

      .multi-check-boxes
        z-index: 10
        position: relative

        ul
          background: $color-panel-bg
          border: 1px solid $color-grey
          border-top: 0
          border-radius: 0 0 3px 3px
          left: 0px
          padding: 8px 8px
          position: absolute
          top: -1rem
          width: 100%
          list-style: none
          max-height: 150px
          overflow: auto

      .multi-check-overselect
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/MultiCheck.vue